import React, { useCallback } from "react";
import { connect } from "react-redux";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";
import { Group } from "@mapmycustomers/shared/types/entity";
import User from "@mapmycustomers/shared/types/User";

import ColorPicker from "@app/scene/map/components/ColorPicker";
import SharePicker from "@app/scene/map/components/SharePicker";
import { updateGroup, updateGroupSharing } from "@app/scene/map/store/groupMode/actions";

import styles from "./GroupProps.module.scss";

interface Props {
  group: Group;
  onUpdateGroup: typeof updateGroup.request;
  onUpdateGroupSharing: typeof updateGroupSharing.request;
}

const GroupProps: React.FC<Props> = ({ group, onUpdateGroup, onUpdateGroupSharing }) => {
  const handleColorChange = useCallback(
    (color: AnyColor) => {
      onUpdateGroup({ group: { ...group, color }, noNotification: true });
    },
    [onUpdateGroup, group]
  );

  const handleSave = useCallback(
    (userIds: User["id"][]) => {
      onUpdateGroupSharing({ group, userIdsToShareWith: userIds });
    },
    [group, onUpdateGroupSharing]
  );

  return (
    <div className={styles.container}>
      <SharePicker
        creatorUserId={group.user.id}
        editable={group.accessStatus.update}
        isGroupSharing
        onChange={handleSave}
        userIds={group.userIds ?? []}
      />
      <ColorPicker
        color={group.color}
        editable={group.accessStatus.update}
        onColorChange={handleColorChange}
      />
    </div>
  );
};

const mapDispatchToProps = {
  onUpdateGroup: updateGroup.request,
  onUpdateGroupSharing: updateGroupSharing.request,
};

export default connect(null, mapDispatchToProps)(GroupProps);
